export const KEYS = [
  'code',
  'name',
  'companyId',
  'companyName',
  'vendorId',
  'vendorName',
  'note',
  'arrCustomerId',
  'objCustomers',
];

export default (data) => {
  let result = KEYS.map((item) => {
    return {
      name: [item],
      value: data[item] || null,
      errors: [],
    };
  });
  return result;
};
